// src/firebase.js

import { db } from './firebaseConfig'; // Assuming you have your Firebase config here
import { collection, addDoc, getDocs, doc, deleteDoc } from 'firebase/firestore';

// src/firebase.js

import axios from 'axios';

// Cloudinary API details
const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;


// Function to upload image to Cloudinary
// Function to upload image to Cloudinary
export const uploadImageToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET); // Unsigned upload preset only

  try {
    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      formData
    );
    return response.data.secure_url;
  } catch (error) {
    console.error('Error uploading image to Cloudinary: ', error.response?.data || error.message);
    throw error;
  }
};


// Fetch all products from Firestore
export const fetchProductsFromFirestore = async () => {
  const querySnapshot = await getDocs(collection(db, 'products'));
  const products = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  return products;
};

// Add a new product to Firestore
export const addProductToFirestore = async (productData) => {
  try {
    const docRef = await addDoc(collection(db, 'products'), productData);
    return { id: docRef.id, ...productData };
  } catch (error) {
    console.error('Error adding product: ', error);
    throw error;
  }
};

// Delete a product from Firestore
export const deleteProductFromFirestore = async (productId) => {
  try {
    await deleteDoc(doc(db, 'products', productId));
  } catch (error) {
    console.error('Error deleting product: ', error);
    throw error;
  }
};
